import { render, staticRenderFns } from "./WordSplit.vue?vue&type=template&id=72571e65&scoped=true&"
import script from "./WordSplit.vue?vue&type=script&lang=js&"
export * from "./WordSplit.vue?vue&type=script&lang=js&"
import style0 from "./WordSplit.vue?vue&type=style&index=0&id=72571e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72571e65",
  null
  
)

export default component.exports